import React from "react";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Form from "../layout/form.jsx";
import Loader from "../layout/loader.jsx";
import { toast } from "react-toastify";
import API from "../../services/api.jsx";
import Helpers from "../../services/helpers.jsx";
import DB from '../../services/db.jsx';
class UserNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      breadcrumb: { title: 'back to Users', path: '/users/list' },
      fields: {
        name: { label: 'User name', type: 'text', required: true },
        email: { label: 'Email address', type: 'email', required: true },
        password: {
          label: 'Password',
          type: 'password',
          required: true,
          errorMessage:
            'Password must contain at least 8 characters, including letters, numbers and symbols',
        },
        role: {
          label: 'Role',
          type: 'select',
          required: true,
          options: [],
        },
        affiliates: {
          label: 'Assigned affiliate(s)',
          type: 'select-multi',
          optionKey: 'affiliates',
          fullWidth: true,
          required: false,
          disabled:
            Helpers.isSuperAdmin() || Helpers.isAffiliateAdmin() ? false : true,
          options: [],
          hidden:
            (Helpers.isSuperAdmin() || Helpers.checkPermissions('users:edit')
              ? false
              : true) || DB.get('user').affiliates.length === 1,
        },
        clients: {
          label: 'Add extra client(s) - Optional',
          type: 'select-multi',
          optionKey: 'clients',
          fullWidth: true,
          required: true,
          options: [],
          hidden: !Helpers.checkPermissions(['clients:edit', 'clients:delete'], true),
          tooltip: `Assign client access to this user
          Use this field to give the user access to a specific client, if they don’t already have access by default.
					Please note:
					- Account Managers only see the clients they’ve created unless assigned more.
					- Affiliate Admins and Managers already have access to all Affiliate clients.
					`,
        },
      },
      entity: {},
    };
    this.afterChange = this.afterChange.bind(this);
    this.saveEntity = this.saveEntity.bind(this);
  }

  componentDidMount() {
    Promise.all([this.loadRoleOptions(), this.loadClientOptions()]);
  }

  loadRoleOptions() {
    API.getAvaliableOptions('roles').then((entities) => {
      const roles = entities?.roles?.map((role) => ({
        key: role.id,
        label: role.name,
      }));
      this.setState((prevState) => ({
        fields: {
          ...prevState.fields,
          role: { ...prevState.fields.role, options: roles },
        },
      }));
    });
  }
  loadClientOptions() {
    API.getAvaliableOptions('clients').then((entities) => {
      const clients = entities?.clients?.map((client) => ({
        key: client.id,
        label: client.name,
      }));
      this.setState((prevState) => ({
        fields: {
          ...prevState.fields,
          clients: { ...prevState.fields.clients, options: clients },
        },
      }));
    });
  }

  afterChange(key, value) {
    if (key === "role") {
      const role = this.state.fields.role.options.find((option) => option.key === value);
      if (Helpers.isClient(role?.label)) {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            affiliates: {
              ...prevState.fields.affiliates,
              hidden: true,
            },
            clients: {
              ...prevState.fields.clients,
              type: "select",
            },
          },
          entity: {
            ...prevState.entity,
            affiliates: null,
            clients: null,
          },
        }));
      } else {
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            affiliates: {
              ...prevState.fields.affiliates,
              hidden: false,
            },
            clients: {
              ...prevState.fields.clients,
              type: "select-multi",
            },
          },
        }));
      }
    }
  }

  saveEntity(fields) {
    for (const [key, value] of Object.entries(this.state.fields)) {
      if (value.error) {
        toast.error("Please fix the errors in the form");
        return;
      }
    }

    this.setState({ loading: true });
    const params = {
      ...fields,
      clients: fields.clients 
        ? (Array.isArray(fields.clients) ? fields.clients : [fields.clients])
        : [],
    };
    API.create('users', params)
      .then(() => {
        toast.success('User has been created');
        this.props.history.push('/users/list');
      })
      .catch(() => {
        // toast.error('An unexpected error has occurred, please try again');
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head title={"Create new user"} breadcrumb={this.state.breadcrumb} />
          <Content>
            <Form
              fields={this.state.fields}
              cancel={() => this.props.history.push("/users/list")}
              save={this.saveEntity}
              entity={this.state.entity}
              afterChange={this.afterChange}
            />
          </Content>
        </>
      );
  }
}

export default UserNew;
